import React from 'react';
import AuthorizedRouting from '../authorized';
import GuestRouting from '../guest';
import { useRootHook } from './root.hook';

const RootRouting: React.FC = (): JSX.Element => {
  const init = useRootHook();
  return init ? <AuthorizedRouting /> : <GuestRouting />;
};

RootRouting.displayName = 'RootRouting';

export default RootRouting;
